/**
 * Функция, которая задерживает выполнение следующего кода на указанное время
 * @param ms - время задержки в миллисекундах
 */
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}